export enum SEGMENT {
	CONNECT = 'connect',
	HOME = 'home',
	REMOVE_CARD = 'remove-card',
	REMOVE_DLK = 'remove-dlk',
	GOODBYE_PAGE = 'goodbye'
}
